// extracted by mini-css-extract-plugin
module.exports = {"root":"wjZ_n4","error":"dDKr6Y"};